import React, { useEffect } from 'react';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import * as Paginator from 'react-bootstrap-table2-paginator';
import Pagination from 'react-bootstrap-table2-paginator';
import Table from 'react-bootstrap-table-next';
import {
  customSizePerPage,
  customTotal,
} from '../../../../components/common/parcelStatusPages';
import { useTranslation } from 'react-i18next';
import { Card, Col, Row } from '@themesberg/react-bootstrap';
import { returnRowBGColor } from '../../../../utils/parcels';
import EmptyTable from '../../../../components/common/EmptyTableView';
import { useDispatch, useSelector } from 'react-redux';
import { setPageNumberInStore } from '../../../../actions/tablePage';

const TableOnly = (props) => {
  const {
    id,
    data,
    columns,
    handleRowClick,
    showRowBgColor = false,
    isFooterRequired = true,
    rowStyle,
    rowClasses,
    manualRowBGCheck = false,
  } = props;
  const dispatch = useDispatch();
  const storedPage = useSelector((state) => state?.pageNumber?.[id] || 1);
  const totalPages = Math.ceil((data?.length || 0) / 10);
  const initialPage = storedPage > totalPages ? 1 : storedPage;
  const handlePageChange = (page) => {
    if (id) {
      dispatch(setPageNumberInStore({ id, page }));
    }
  };
  const defaultCellFormatter = (cell) => {
    return cell ?? '-';
  };

  const formattedColumns = columns.map((col) => ({
    ...col,
    formatter: col.formatter || defaultCellFormatter,
  }));
  const { t } = useTranslation();

  return (
    <ToolkitProvider
      exportCSV
      keyField="id"
      sort
      columns={formattedColumns}
      data={data || []}
      wrapperClasses="table-responsive"
    >
      {({ baseProps }) => (
        <Paginator.PaginationProvider
          pagination={Pagination({
            custom: true,
            showTotal: true,
            alwaysShowAllBtns: true,
            totalSize: data?.length,
            onPageChange: handlePageChange,
            page: initialPage,
            paginationTotalRenderer: customTotal,
            sizePerPageRenderer: customSizePerPage,
          })}
        >
          {({ paginationProps, paginationTableProps }) => (
            <>
              <Card>
                <div className="table-responsive py-2">
                  <Table
                    rowClasses={
                      rowClasses
                        ? (row) => rowClasses(row)
                        : (row) => {
                            const rowBGColor = !showRowBgColor
                              ? ''
                              : returnRowBGColor(
                                  manualRowBGCheck
                                    ? row?.isManualCalculation
                                      ? 'delivered'
                                      : 'pending'
                                    : row?.dashboardStatus ||
                                        row?.mobileStatus ||
                                        row?.status ||
                                        row?.isManualCalculation
                                );
                            return `${rowBGColor} border-bottom`;
                          }
                    }
                    noDataIndication={<EmptyTable />}
                    {...baseProps}
                    {...paginationTableProps}
                    bodyClasses="border-0"
                    classes="table-flush dataTable-table"
                    {...(handleRowClick && {
                      rowEvents: {
                        onClick: (e, row, index) => {
                          handleRowClick(row);
                        },
                      },
                    })}
                    {...(showRowBgColor && {
                      rowClasses: (row) => {
                        const rowBGColor = returnRowBGColor(
                          manualRowBGCheck
                            ? row?.isManualCalculation
                              ? 'delivered'
                              : 'pending'
                            : row?.status
                        );
                        return `${rowBGColor} border-bottom`;
                      },
                    })}
                    rowStyle={rowStyle}
                  />
                  {isFooterRequired && (
                    <Card.Footer>
                      <Row>
                        <Col xs={12} md={4} className="py-1">
                          <Paginator.SizePerPageDropdownStandalone
                            {...paginationProps}
                            paginationSize={5}
                            sizePerPageList={[{ text: '5', value: 5 }]}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          className="d-flex align-items-center py-1"
                        >
                          <Paginator.PaginationTotalStandalone
                            {...paginationProps}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                        >
                          <Paginator.PaginationListStandalone
                            {...paginationProps}
                          />
                        </Col>
                      </Row>
                    </Card.Footer>
                  )}
                </div>
              </Card>
            </>
          )}
        </Paginator.PaginationProvider>
      )}
    </ToolkitProvider>
  );
};

export default TableOnly;
